export const VIEW_ALL_GAMES_IMG = '/assets/images/about-icon/games/view_all_img.png'
